module.exports = __webpack_public_path__ + "img/l4.96a7dc75.png";